module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('header', [_c('p', {
    staticClass: "chap-title"
  }, [_vm._v("The Game of the Goose"), _c('br'), _vm._v("and Other Animals")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he medieval Game of the Goose – a swift and intense race game popular all over Europe – underwent a transformation in the nineteenth century. Often, animals, especially monkeys mocking human behavior, substituted for the geese, adding a unique comedic element to the game.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Perhaps the Game of the Goose is the most seminal of all printed board games. It has given birth to literally thousands of variants throughout the centuries – all straightforward dice games played on a spiraled track with no option of movement, but spanning a vast array of themes. To this day, the game continues to be played, with new variations still emerging, particularly in the Netherlands.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Its earliest mentions trace back to fifteenthcentury Italy, mostly as counsel against its play or even as legal bans – a clear indicator of its popularity. The game’s association with gambling stirred this disapproval. In fact, when Francesco de’ Medici gifted the game to the Court of Philip II of Spain in the late sixteenth century, Philip’s jester, ‘Gonzalillo,’ lamentably wrote to Francesco, ‘Cursed be your servant, Luis Dovara, who brought this diabolic game known as Gioco dell’Oca [Game of the Goose], played with two dice… Played in Tuscany, may the creator be damned for the Prince, the Infanta, and Luis Tristan have lost 40 scudi due to it.’ The game’s popularity radiated across Europe during this period, primarily through print, and it remained a beloved pastime for two centuries. To grasp its enduring appeal, consider the New and Entertaining Children’s Game of the Goose, tailored for the young ones in the Netherlands. While branded as ‘new,’ this version and its regulations would resonate deeply with Gonzalillo and the Spanish Court. This ‘classic’ rendition, barring minor rule tweaks, would have been universally recognized throughout Western Europe.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Upon inspecting the game, its namesake becomes clear: geese are prominently featured across the game’s track. Why geese? They’re likely symbols of luck in Italy, and in the game, geese typically herald good fortune. Landing on a goose space allows the player to roll again, doubling their move. Players utilize two dice, and with a track spanning just 63 spaces, it makes for a dynamic game. However, there’s an intriguing nuance: rolling a nine initially could, in theory, let a player jump from goose to goose and win instantly. To counter this, a unique rule is applied to an initial roll of nine, sending the player either to space 26 or 53, depending on the specific dice combination. This doesn’t guarantee victory, but it’s indeed an auspicious roll, especially landing on space 53 where the next roll could be a winning one.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Yet, clinching the final space isn’t typically straightforward. Numerous pitfalls exist, where the unlucky player must forfeit a stake to the winner’s pool. While stakes can range in value, children often wager with candies, nuts, or tiny cookies. Among the hazards, death (space 58) is the most dreaded as players must start over. But spaces like the well and the prison also spell trouble: there, a player remains stuck until another player arrives to take their place. An appealing aspect of the game is that overshooting the last space results In moving backward by the extra points, adding an element of suspense.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("From a broader perspective, the game can be perceived as an allegory for human life. The geese might signify fortuitous events or possibly divine interventions on a spiritual journey, whereas the obstacles symbolize life’s challenges. Delving deeper into symbolism, for instance, the bridge at space 6 might signify the transition into adulthood, while other spaces carry specific interpretations. This kind of interpretation, especially considering the game’s medieval origins in a time when symbolism was prevalent, isn’t far-fetched. Even the game’s numerology, like the victory number 63 associated with a significant life crisis, supports this allegorical view. By the nineteenth century, however, these philosophical interpretations had faded into obscurity, and the Game of the Goose was enjoyed simply as a game.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("New and entertaining Children’s Game of the Goose, for the Youth of the Netherlands. Zalt-Bommel: Noman about 1825")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("D")]), _vm._v("espite its allure, by the start of the nineteenth century, the Game of the Goose was seen as outdated, at least by adults. This perception marked the beginning of its evolution into a game predominantly for children. A notable indication of this transition is a version from the Netherlands, characterized by a central illustration that depicts young individuals engrossed in the game. The sheer intensity is palpable - the boy on the left appears almost too anxious to watch. This iteration of the game is beautifully engraved, most notably showcasing a striking image of Death on space 58, confidently marching with his scythe slung over his shoulder. Subsequent children’s editions of the game often opted for a milder representation in the death space. Instead of the traditional garden of paradise, the winning space in this version prominently displays a ‘horn of plenty.’")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Game of the Goose. Épinal: Pinot & Sagaire about 1860")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("A")]), _vm._v("lthough the subsequent game, a French version from around 1860, appears markedly different from the Dutch game, it remains a rendition of the classic Game of the Goose, or ‘Jeu de l’oie’ in French. The primary distinction lies in the non-active spaces; previously empty, they now boast vibrant illustrations. These enhancements aim to elevate the game’s appeal. However, they inadvertently create visual competition with the active spaces, such as the geese and hazards, which can make gameplay somewhat challenging. In this version, the depicted scenes on the track lack a cohesive theme and are merely for children’s amusement. In the bottom left corner, an illustration portrays a young man challenging a girl: ‘You lose, mademoiselle – I have 63!’ This game originated from Épinal, a provincial region in northeastern France, which became renowned for its mass production of printed visuals. This encompassed not only games but also a myriad of popular prints, elevating it to a significant global industry. The production value of the game is modest, utilizing affordable, machine-made paper. The color application appears rudimentary, with individual stencils for each hue dabbed on using a "), _c('i', [_vm._v("pochoir")]), _vm._v(", a small cloth pad. Playing tokens are printed on the side, designed to be snipped out and assembled.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg15_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The Royal Game of Goose. London: Edward Wallis about 1840")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("G")]), _vm._v("ames fashioned after a goose emerged at the century’s onset. This particular version, credited to Edward Wallis of London (as noted in the minuscule text on one of the eggs), hails from around 1840. This was a period when the Game of the Goose’s allure was waning in England. The dominant goose imagery undeniably grabs attention, but the game remains largely true to its classic roots. A notable variation is the absence of the first two geese on the track, a common modification in English Goose games. This adjustment eliminates the need for a unique rule governing an initial dice roll of nine, thereby removing the possibility of a swift victory. Perhaps the austere English mindset deemed such a quick win unsporting, leading to the removal of these geese. The game’s guidelines specify that each participant should possess twelve counters termed ‘for fish.’ This terminology likely derives from a misinterpretation of the French word "), _c('i', [_vm._v("fiches")]), _vm._v(", which refers to counters used as stakes in gaming. In England, counters often adopted a fish-like shape, playfully nodding to this linguistic pun.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Game of the Goose. Milan: Eliseo Macchi about 1900")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("C")]), _vm._v("ertain Game of the Goose variations expand the traditional 63-space layout to encompass 90 spaces. This modification traces its origins to Italy, where the number 90 holds a special allure. This fondness for the number is due to its association with the Italian State Lottery, which draws from 90 balls. One early outcome of the Italian unification in the 1860s was the consolidation of regional lotteries, triggering a nationwide gambling frenzy. Ever cautious, game manufacturers included a stipulation that, by mutual agreement, participants could opt to play using the conventional endpoint at space 63. Adapting the goose-themed spaces, spaced by nine, to fit the extended layout posed no challenge. However, the introduction of new obstacles became necessary: notably, the "), _c('i', [_vm._v("fountain")]), _vm._v(" at space 71, which serves as an obstruction, and the "), _c('i', [_vm._v("tower")]), _vm._v(" at space 82, governed by rules akin to those of the "), _c('i', [_vm._v("prison")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("New Improved Goose Game. Nuremberg: Campe about 1820")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("G")]), _vm._v("erman variations of the Game of the Goose from the 19th century exhibited remarkable deviations from the classic design, introducing a range of rule changes. One such variant, "), _c('i', [_vm._v("The New Improved Goose Game")]), _vm._v(", retains the traditional 63 spaces but incorporates distinctive alterations, including alternative depictions for several of the established obstacles. A notable feature of this game is the depiction of geese facing either in the direction of the game’s progression or against it. As delineated in the provided rules, geese facing forward serve their typical role, allowing players to double their dice throw, while those oriented backward halt players in their tracks. Interestingly, this specific rule appears exclusive to German versions. However, in the Netherlands, players often adopt a similar rule, deciding upon it by mutual agreement, even though it isn’t formally documented.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg21_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "height": "16em"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg22_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Game of the Monkeys. Metz: Delhalt about 1880")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("A")]), _vm._v(" popular way to update the Goose game was to replace the geese with monkeys. This wasn’t a new concept: in fact, a game with this exact substitution was printed in Italy as early as 1588, around the same time as the first printed Games of the Goose. The fascination in art for portraying monkeys as caricatures of humans ("), _c('i', [_vm._v("singerie")]), _vm._v(") has been prominent in various eras, but the 19th century saw a surge of such depictions, and printed games picked up on this trend. Occasionally, the monkey games were direct replacements in the traditional Game of the Goose, such as in the "), _c('i', [_vm._v("Game of the Monkeys")]), _vm._v(", produced in Metz in the northeast of France. The primary attraction here is the humorous depictions of monkeys on the track, all engaging in very human-like activities: smoking, taking a fancy stroll, or trying (and failing) to catch a butterfly. However, the illustrations outside the track are equally intriguing, especially the two monkeys at the bottom, fervently competing in a game of dice.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg23_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The New Game of the Monkey. London: Wallis 1820")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("O")]), _vm._v("ur second monkey game is from England. At first glance, "), _c('i', [_vm._v("The New")]), _vm._v(" "), _c('i', [_vm._v("Game of the Monkey")]), _vm._v(" appears to be a standard 63-space Goose game with monkeys in place of geese. However, there are notable differences. Rather than the usual doubling of the throw, specific rules are assigned to each monkey space. For instance, the "), _c('i', [_vm._v("Dancing Monkeys")]), _vm._v(" require a player to pay one stake for dance lessons, the "), _c('i', [_vm._v("Soldier")]), _vm._v(" can march to No. 13, and the "), _c('i', [_vm._v("Dandy")]), _vm._v(" has to pay two stakes for his silliness. Nonetheless, the hazard spaces closely resemble those in the Goose game and occupy the same positions. For instance, at the "), _c('i', [_vm._v("Bridge, you")]), _vm._v(" have to pay a stake for the Toll; at the "), _c('i', [_vm._v("Inn")]), _vm._v(", you must skip a turn and have a drink; if you land on the "), _c('i', [_vm._v("Well")]), _vm._v(", you have to wait until another player comes to help you out. The 58th space, showcasing the despondent "), _c('i', [_vm._v("Gamester")]), _vm._v(", mirrors the death space, meaning you have to start over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The corner decorations are amusing, even though they’re unrelated to the game’s mechanics. One depicts a judge puzzled by a red herring, with a book titled ‘Black…’ (likely referring to Blackstone’s "), _c('i', [_vm._v("Commentaries on the")]), _vm._v(" "), _c('i', [_vm._v("Laws of England")]), _vm._v(") on the floor nearby. The opposite corner features two monkeys punishing a dog tethered to a pot. Above, a monkey gazes at its reflection in a mirror. Meanwhile, in the last corner, a monkey is ensnared in a steel trap — a potential reference to the anti-slavery movement? The ‘lady’ being wooed at space 14 sports a pot as a hat, reminiscent of Tenniel’s depiction of Tweedledum in Lewis Carroll’s later work, "), _c('i', [_vm._v("Through")]), _vm._v(" "), _c('i', [_vm._v("the Looking-Glass")]), _vm._v(". The monkey at space 23 dons attire akin to Little Red Riding Hood, while the one at space 18 has a bellows for a hat. Truly, a delightful touch of English eccentricity!")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg25_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg26_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The Hare and the Tortoise. London: Spooner 1859")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("O")]), _vm._v("ther animals were used to refresh the Game of the Goose. The Hare and the Tortoise, released in London in 1859 as a stunning color lithograph, offers an innovative twist by splitting the game’s path between a magnificent illustration of the tortoise and an even grander depiction of the hare. The game starts at the hare’s back left foot, snakes between its hind legs up to space 8 — but you’ll find space 9 on the tortoise. After that, the path returns to the hare before branching out once more. Some spaces feature a small image of a hare; here, the player has to skip a turn and contribute two counters to the pool. On spaces showcasing a tortoise, the player doubles their throw, similar to the Game of the Goose. Many spaces located on the tortoise reward the player with three counters. Additionally, there are hazard spaces that echo the Game of the Goose. This game, like its predecessor, spans 63 spaces in length. Players need to stay sharp when moving their markers: if someone places theirs on the wrong number, they owe two counters to the pool.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("New Game of the Hare. Weissenberg: G Burkhardt’s successors late 19th century")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("H")]), _vm._v("unting has always been a cherished activity among Germans, and the "), _c('i', [_vm._v("New Game of the Hare")]), _vm._v(" brings this passion to the table. It’s a straightforward game, played with two dice, yet the rules aren’t immediately clear from the images. For instance, spaces 34, 45, 58, and 64, all showcasing a hare, serve as obstacles, sending you back to the position from which you rolled. However, not all spaces featuring a hare have this consequence. In the author’s version of the game, a prior owner has marked these challenging spaces with an ‘X’ to help recall the rules. Space 57, which depicts a puzzled hunter who’s seemingly lost track of the hare, mandates that the player begin anew.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg29_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b87e6e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 69
// module chunks = 0